__turbopack_context__.v({
  "login-forgot-password": "login-module-scss-module__JRt4va__login-forgot-password",
  "login-form": "login-module-scss-module__JRt4va__login-form",
  "login-form-container": "login-module-scss-module__JRt4va__login-form-container",
  "login-form-error": "login-module-scss-module__JRt4va__login-form-error",
  "login-logo": "login-module-scss-module__JRt4va__login-logo",
  "login-logo-container": "login-module-scss-module__JRt4va__login-logo-container",
  "login-panel": "login-module-scss-module__JRt4va__login-panel",
  "login-status-content": "login-module-scss-module__JRt4va__login-status-content",
  "login-submit": "login-module-scss-module__JRt4va__login-submit",
  "maintenance-message": "login-module-scss-module__JRt4va__maintenance-message",
  "maintenance-message-subtext": "login-module-scss-module__JRt4va__maintenance-message-subtext",
  "special-input": "login-module-scss-module__JRt4va__special-input",
  "version-info": "login-module-scss-module__JRt4va__version-info",
});
